/**
 * 地图与列表切换
 * 
 * @Author: Focci
 * @Date: 2023-12-01 10:21:48
 * @Last Modified by: Focci
 * @Last Modified time: 2023-12-01 10:21:48
 */

import PropTypes from 'prop-types'
import SVGMap from '@img/map-locale.svg'
import SVGMenu from '@img/menu.svg'
import { ButtonBase } from '@comp/material'
import { useTranslations } from 'next-intl'

export default function ListingMapSwitcher({
  value = '',
  onChange = () => {}
}) {
  const th = useTranslations('house')
  const isListing = value === 'listing'

  return (
    <ButtonBase 
      className="rounded-full"
      onClick={() => onChange({ type: isListing ? 'map' : 'listing' })}
    >
      <div 
        className="
          flex items-center gap-x-1 rounded-full bg-white shadow-large
          py-2 px-6 text-f.8
        "
      >
        {!isListing && <SVGMenu />}
        {isListing && <SVGMap width=".9rem" />}
        <span className="whitespace-nowrap">
          { !isListing ? th('listing') : th('map')}
        </span>
      </div>
    </ButtonBase>
  )
}

ListingMapSwitcher.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
}
